import { getRelativePath } from "base/shared/Utils";

const BASE_PATH = "/conversation";

export const getConversationPath = ({ connectionId }) =>
  connectionId
    ? getRelativePath(`${BASE_PATH}/${connectionId}${window.location.search}`)
    : "";
